var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeak = function SvgPeak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "M6.687 22.588c.224 0 .406.18.406.404v8.605a.405.405 0 0 1-.406.403H.407A.405.405 0 0 1 0 31.597v-8.605c0-.223.182-.404.406-.404Zm24.907-5.378c.224 0 .406.18.406.403v13.984a.405.405 0 0 1-.406.403h-6.281a.405.405 0 0 1-.406-.403V17.613c0-.222.182-.403.406-.403ZM6.28 23.395H.812v7.798h5.469v-7.798Zm24.907-5.378h-5.469v13.176h5.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "m6.602 10.531-.036.045a.403.403 0 0 0 .338.628h5.874v20.393c0 .222.182.403.406.403h6.281l.055-.004a.404.404 0 0 0 .351-.4V11.205h5.875a.403.403 0 0 0 .302-.673L16.627.134a.41.41 0 0 0-.604 0L6.602 10.53Zm9.723-9.525 8.509 9.392h-5.369l-.055.003a.404.404 0 0 0-.35.4l-.001 20.392H13.59V10.801l-.003-.055a.405.405 0 0 0-.403-.348H7.815z"
  }))));
};
export default SvgPeak;